<app-side-pop-up>
  <div header class="cart-popup-header d-flex align-items-center" data-qa="cart-popup">
    <div class="cart-popup-header__check">
      <app-svg dimension="1.5rem" iconName="CircleCheck"></app-svg>
    </div>
    <span class="cart-popup-header__title">
      {{ 'habaAddToCartPopup.headline' | cxTranslate }}
    </span>
  </div>

  <div class="cart-popup-container" *ngIf="product$ | async as product">
    <div class="cart-popup-current">
      <app-product-card-inline
        [product]="product"
        [readonly]="true"
        [quantity]="(quantity$ | async) || 1"
        [personalizationImage]="personalizationImage$ | async"
      ></app-product-card-inline>

      <div class="cart-popup-current__actions">
        <button
          class="btn btn-green w-100"
          data-qa="cart-popup-button-to-cart"
          (click)="navigateCart()"
        >
          {{ 'habaAddToCartPopup.toCart' | cxTranslate }}
        </button>
        <button
          class="btn btn-secondary w-100"
          data-qa="cart-popup-button-continue"
          (click)="popupService.close()"
        >
          {{ 'habaAddToCartPopup.continue' | cxTranslate }}
        </button>
      </div>
    </div>

    <ng-container *ngIf="recommendations?.length">
      <div class="cart-popup-divider"></div>
      <h2 class="cart-popup-reco-title">
        {{ 'habaAddToCartPopup.recommendationsTitle' | cxTranslate }}
      </h2>
      <div class="cart-popup-reco-list">
        @for (reco of recommendations; track reco.code; let i = $index) {
          <app-product-card-inline
            [product]="reco"
            [index]="i"
            (addToCart)="addRecommendationToCart($event)"
          ></app-product-card-inline>
        }
      </div>
    </ng-container>
  </div>
</app-side-pop-up>
